import { useCallback, useState } from 'react';

// eslint-disable-next-line default-param-last
export function useDisclosure(initialState?: boolean, callbacks?: { onOpen?: () => void; onClose?: () => void }) {
    const { onOpen, onClose } = callbacks || {};
    const [opened, setOpened] = useState(initialState || false);

    const open = useCallback(() => {
        setOpened((isOpened) => {
            if (!isOpened) {
                onOpen?.();
                return true;
            }
            return isOpened;
        });
    }, [onOpen]);

    const close = useCallback(() => {
        setOpened((isOpened) => {
            if (isOpened) {
                onClose?.();
                return false;
            }
            return isOpened;
        });
    }, [onClose]);

    const toggle = useCallback(() => {
        if (opened) {
            close();
            return;
        }
        open();
    }, [close, open, opened]);

    return [opened, { open, close, toggle }] as const;
}
